export const OperatorEnum = Object.freeze({
                                              LT: "<",
                                              LTE: "<=",
                                              GT: ">",
                                              GTE: ">="
                                          });